module.exports = __webpack_public_path__ + "img/Dashboard_logo.a4fb0b08.svg";